import { HttpClient } from 'api/http-client';
import { Meeting, MeetingFeatureFlag, MeetingSettings } from './types';

class MeetingClient extends HttpClient {
  public getMeetings = (): Promise<Meeting[]> =>
    this.get<Meeting[]>('/meetings');

  public getMeetingSettings = (): Promise<MeetingSettings> =>
    this.get<MeetingSettings>('/meeting/setting');

  public updateMeetingSettings = (
    data: MeetingSettings,
  ): Promise<MeetingSettings> =>
    this.put<MeetingSettings, MeetingSettings>('/meeting/setting', data);

  public getMeetingsBetaEnabled = (): Promise<MeetingFeatureFlag> =>
    this.get('/meetings/ai-fills/feature-flag');
}

export const MeetingAPI = new MeetingClient();
